<h2 mat-dialog-title>{{'commonerrormessageDialog.error' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <mat-dialog-content fxLayoutAlign="center start">
    <mat-icon aria-label="" color="warn">error</mat-icon>
  </mat-dialog-content>
  <p>{{firstMessage}}<br>
    {{secondMessage}}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{'commonerrormessageDialog.ok' | translate}}</button>
  </mat-dialog-actions>
</div>